import React from 'react';
import { ArrowRight, Flame, ShieldCheck } from 'lucide-react';

export default function HeroBanner({ onVerColecao, onExplorarKits }) {
  return (
    <section className="relative overflow-hidden pt-6 pb-12 md:py-16 bg-gradient-to-b from-[#080b09] via-[#0c100e] to-[#080b09] border-b border-urb-border/50">
      {/* Glow de fundo neon esportivo */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-urb-primary/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-10 left-10 w-80 h-80 bg-urb-primary/5 rounded-full blur-2xl pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          
          {/* Coluna de Texto & Ação */}
          <div className="lg:col-span-7 flex flex-col items-start space-y-6">
            
            {/* Badge de Drop */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-urb-primary/10 border border-urb-primary/30 text-urb-primary text-xs font-bold uppercase tracking-wider">
              <span className="w-2 h-2 rounded-full bg-urb-primary animate-pulse" />
              <Flame className="w-3.5 h-3.5 text-urb-primary" />
              <span>DROP PERFORMANCE OFICIAL 2026</span>
            </div>

            {/* Título Principal */}
            <div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight uppercase leading-[1.08]">
                LOJA <span className="text-urb-primary inline-block drop-shadow-[0_0_20px_rgba(138,230,0,0.4)]">URB</span>
              </h1>
              <p className="text-xl sm:text-2xl font-bold text-gray-200 mt-2 uppercase tracking-wide">
                Corra com a nossa identidade.
              </p>
            </div>

            {/* Descrição */}
            <p className="text-base sm:text-lg text-urb-text-secondary max-w-xl leading-relaxed">
              Vista a comunidade. Equipamentos desenvolvidos com a mais avançada tecnologia 
              têxtil esportiva para você quebrar seus recordes pessoais com conforto e máxima respirabilidade.
            </p>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-4 pt-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={onVerColecao}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 rounded-xl bg-urb-primary text-black font-extrabold text-sm uppercase tracking-wider hover:bg-urb-primary-hover hover:scale-[1.02] active:scale-[0.98] transition-all shadow-[0_0_25px_rgba(138,230,0,0.3)] cursor-pointer"
              >
                <span>VER COLEÇÃO</span>
                <ArrowRight className="w-4 h-4 stroke-[3]" />
              </button>

              <button
                type="button"
                onClick={onExplorarKits}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-urb-card-light/80 hover:bg-urb-card-light text-white font-bold text-sm uppercase tracking-wider border border-urb-border hover:border-urb-primary/40 transition-all cursor-pointer"
              >
                <span>EXPLORAR KITS</span>
              </button>
            </div>

            {/* Selo Autêntico */}
            <div className="flex items-center gap-2 text-xs text-urb-text-muted pt-2">
              <ShieldCheck className="w-4 h-4 text-urb-primary" />
              <span>Garantia de autenticidade oficial • Primeira troca grátis em até 30 dias</span>
            </div>

          </div>

          {/* Coluna da Imagem dos Produtos Oficiais */}
          <div className="lg:col-span-5 relative flex items-center justify-center">
            <div className="relative w-full max-w-md lg:max-w-none">
              {/* Moldura com Aura Neon */}
              <div className="absolute inset-0 bg-gradient-to-tr from-urb-primary/20 via-transparent to-transparent rounded-3xl blur-xl" />
              <div className="relative rounded-3xl bg-gradient-to-b from-urb-card-light/40 to-urb-dark/80 p-4 sm:p-6 border border-urb-border/80 shadow-2xl backdrop-blur-sm group">
                <img
                  src="/images/banner/hero-products.png"
                  alt="Produtos Oficiais URBRACE - Camisas, Bonés e Acessórios"
                  className="w-full h-auto object-contain drop-shadow-[0_20px_30px_rgba(0,0,0,0.8)] group-hover:scale-105 transition-transform duration-500 ease-out"
                  onError={(e) => {
                    // Fallback caso a imagem precise de caminho relativo
                    e.target.src = '/loja/images/banner/hero-products.png';
                  }}
                />
                <div className="absolute bottom-4 right-4 bg-urb-dark/90 backdrop-blur-md px-3 py-1.5 rounded-lg border border-urb-border text-[11px] font-bold text-urb-primary flex items-center gap-1.5 shadow-lg">
                  <span className="w-1.5 h-1.5 rounded-full bg-urb-primary" />
                  OFICIAL URBRACE
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
